import { useAppDispatch } from "hooks/redux";
import { Navigate } from "react-router-dom";
import { setToken } from "auth/VendorAuth/vendorUserSlice";

const Logout = () => {
  const dispatch = useAppDispatch();
  dispatch(setToken(undefined));

  return <Navigate to="/" replace={true} />;
};

export default Logout;
